module.exports = {
	isDebug: false,

	// Set to true to enable https://github.com/NekR/offline-plugin
	// NOTE: also ensure plugin code is imported in `main.js`
	offline: false

}



// WEBPACK FOOTER //
// ./src/config/build.js